import {isDevEnv} from '../../../utils/platform';
import {AnnouncementItems} from '../consts/types';
import {ver2501} from './ver2501';

export const getAnnouncements = () => {
    return {
        '25.01': ver2501()
    };
};

export const getVersionAnnouncements: (
    PriorityVersion
) => AnnouncementItems[] = PriorityVersion => {
    if (isDevEnv()) {
        return getAnnouncements()['25.01'];
    }
    return getAnnouncements()[PriorityVersion];
};
